// Import Packages
import React from 'react';

// import Helpers
import { numberToLetters } from '../../../../../../../helpers/helper';

function RowSelection({ v, type, dataTableValue, setDataTableValue, size, captureDown, captureOver }) {

    return (
        v.slice(0, size === 'medium' ? 4 : 30).map((row, index) => {
            if (size === 'medium') {
                row = row.slice(0, 2);
            }
            if (index === 0) {
                return type === 'string-single-row' ? (
                    <tr onClick={() => setDataTableValue([index])}
                        className={`${dataTableValue && dataTableValue.find(x => x === index) !== undefined ? 'active-col-for-header' : ''}`}>
                        {
                            row.map((col, colIndex) =>
                                <th>
                                    {
                                        colIndex === 0 &&
                                        <span className='tr-row-number'>
                                            {index + 1}
                                        </span>
                                    }
                                    <span className='column-letter-name'>
                                        {numberToLetters(colIndex)}
                                    </span>
                                    {col}
                                </th>
                            )
                        }
                    </tr>
                ) : (
                    <tr onMouseOverCapture={(e) => captureOver(index)} onMouseDownCapture={(e) => captureDown(e, index)}
                        className={`${dataTableValue && dataTableValue.find(x => x === index) !== undefined ? 'active-col-for-header' : ''}`}>
                        {
                            row.map((col, colIndex) =>
                                <th>
                                    {
                                        colIndex === 0 &&
                                        <span className='tr-row-number'>
                                            {index + 1}
                                        </span>
                                    }
                                    <span className='column-letter-name'>
                                        {numberToLetters(colIndex)}
                                    </span>
                                    {col}
                                </th>
                            )
                        }
                    </tr>
                )
            }
            return type === 'string-single-row' ? (
                <tr onClick={() => setDataTableValue([index])}
                    className={`${dataTableValue && dataTableValue.find(x => x === index) !== undefined ? 'active-col' : ''}`}>
                    {
                        row.map((col, colIndex) =>
                            <td style={{ cursor: 'default' }}>
                                {
                                    colIndex === 0 &&
                                    <span className='tr-row-number'>
                                        {index + 1}
                                    </span>
                                }
                                {col}
                            </td>
                        )
                    }
                </tr>
            ) : (
                <tr onMouseOverCapture={(e) => captureOver(index)} onMouseDownCapture={(e) => captureDown(e, index)}
                    className={`${dataTableValue && dataTableValue.find(x => x === index) !== undefined ? 'active-col' : ''}`}>
                    {
                        row.map((col, colIndex) =>
                            <td style={{ cursor: 'default' }}>
                                {
                                    colIndex === 0 &&
                                    <span className='tr-row-number'>
                                        {index + 1}
                                    </span>
                                }
                                {col}
                            </td>
                        )
                    }
                </tr>
            )
        })
    )

}

export default RowSelection;